
import { Device, Consumer } from './types';
import { getEnergyDevices } from './data/energyDevices';
import { getGasDevices } from './data/gasDevices';
import { getWaterDevices } from './data/waterDevices';
import { getConsumers } from './data/consumers';

// Re-export the device getter functions for external use
export { getEnergyDevices, getGasDevices, getWaterDevices, getConsumers };

// Generate static samples for immediate use
export const sampleDevices: Device[] = [
  ...getEnergyDevices(),
  ...getGasDevices(),
  ...getWaterDevices()
];

export const sampleConsumers: Consumer[] = getConsumers();
